import { Button } from '@mantine/core';
import { FacebookLogoIcon, GoogleLogoIcon } from '@phosphor-icons/react';
import type { FC } from 'react';

import { env } from '../../../env.ts';

import styles from './SocialLoginButton.module.css';

const iconToComponent = {
  google: GoogleLogoIcon,
  facebook: FacebookLogoIcon,
} as const;

interface SocialLoginButtonProps {
  text: string;
  type: 'google' | 'facebook';
  loading?: boolean;
}

export const SocialLoginButton: FC<SocialLoginButtonProps> = ({ text, type, loading = false }) => {
  const Icon = iconToComponent[type];

  const { protocol, hostname, port } = globalThis.location;

  const localBaseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  const href = `${env.VITE_DIRECTUS_API_URL}/auth/login/${type}?redirect=${localBaseUrl}/social-login`;

  return (
    <Button
      fullWidth
      classNames={styles}
      component="a"
      ff="text"
      fw={500}
      h={64}
      href={href}
      leftSection={<Icon size={28} />}
      loading={loading}
      radius="xl"
      size="lg"
      styles={{ label: { fontSize: 20 } }}
      variant="outline"
    >
      {text}
    </Button>
  );
};
